import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:4011';

// Create axios instance with default config
const apiClient = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add request interceptor to include auth token
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('accessToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

export interface Subscription {
  id: string;
  userId: string;
  stripeCustomerId: string | null;
  stripeSubscriptionId: string | null;
  stripePriceId: string | null;
  status: string;
  currentPeriodStart: string | null;
  currentPeriodEnd: string | null;
  cancelAtPeriodEnd: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface Payment {
  id: string;
  userId: string;
  stripePaymentId: string;
  amount: number;
  currency: string;
  status: string;
  description: string | null;
  receiptUrl: string | null;
  createdAt: string;
}

export const paymentsService = {
  /**
   * Create a Stripe checkout session
   */
  async createCheckoutSession(): Promise<{ url: string }> {
    const { data } = await apiClient.post<{ url: string }>(
      '/api/payments/create-checkout-session',
    );
    return data;
  },

  /**
   * Create a Stripe customer portal session
   */
  async createPortalSession(): Promise<{ url: string }> {
    const { data } = await apiClient.post<{ url: string }>(
      '/api/payments/create-portal-session',
    );
    return data;
  },

  /**
   * Get current user's subscription
   */
  async getSubscription(): Promise<Subscription | null> {
    const { data } = await apiClient.get<Subscription>('/api/payments/subscription');
    return data;
  },

  /**
   * Get payment history
   */
  async getPaymentHistory(): Promise<Payment[]> {
    const { data } = await apiClient.get<Payment[]>('/api/payments/history');
    return data;
  },
};

export default paymentsService;
